import "./style.scss";

import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import MessageBlock from "components/shared/MessageBlock";
import StyledButton from "components/shared/StyledButton";
import type { IFormStep } from "containers/TermFormContainer";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IFormSidebar {
    /**
     * The components for each step.
     */
    steps: IFormStep[];
    /**
     * Index of current step.
     */
    currentStep: number;
    /**
     * Data for summary of steps once passed
     */
    data: string[];
    /**
     * Triggers modal to confirm leaving the form
     */
    onExit: () => void;
    /**
     * Triggers function to change step when clicking on name of step
     */
    onStepChange: (step: number) => void;
    /**
     * Text for the exit button.
     */
    exitBtnText: string | undefined;
    infoLink?: { type: string; link: string; context?: "female" | "male" };
}

/**
 * Sidebar that appears only on mode "new" of the parent Form component.
 */
const FormSidebar = ({ steps, currentStep, data, onExit, onStepChange, exitBtnText, infoLink }: IFormSidebar) => {
    const [t] = useTranslation();
    const [stepError, setStepError] = useState(false);

    /**
     * Displays error when not possible to move from current step.
     * @param conditionPassed Boolean that checks if condition to move to next step has passed.
     * @param index Index of step they want to go to.
     */
    const handleError = (conditionNotPassed: boolean | undefined, index: number) => {
        if (!conditionNotPassed) {
            setStepError(false);
            onStepChange(index);
        }
        conditionNotPassed && setStepError(true);
    };

    return (
        <div className="form-sidebar">
            {/* <StyledButton buttonType='secondary' className='exit-btn' onClick={() => onExit()}><KeyboardBackspaceIcon /><span>{t("ConnectTitle.Exit")} {exitBtnText}</span></StyledButton> */}
            <div className="form-steps">
                {steps.map((step, index) => {
                    const conditionNotPassed = steps.slice(0, index).some((step) => step?.conditionToDisable);
                    return (
                        <div
                            className="step"
                            key={`step-${index}`}
                            onClick={() => handleError(conditionNotPassed, index)}
                        >
                            <div className="progress-container">
                                <div
                                    className={`progress-bar ${
                                        currentStep === index ? "active" : currentStep > index ? "passed" : ""
                                    }`}
                                ></div>
                            </div>
                            <div className="steps-container">
                                <button type="button" className="btn-step">
                                    <span
                                        className={`steps-name ${
                                            currentStep === index ? "active" : currentStep > index ? "passed" : ""
                                        }`}
                                    >
                                        {step.stepTitle}{" "}
                                    </span>
                                </button>
                                {currentStep > index && data[index] && (
                                    <span className="old-step-details">{data[index]}</span>
                                )}
                                {currentStep === index && stepError && step?.conditionToDisable && (
                                    <span className="step-error">{t("ConnectTitle.StepError")}</span>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            {infoLink && (
                <MessageBlock
                    type="info"
                    text={t("MessageBlock.FormDocument", {
                        context: infoLink?.context ?? "male",
                        type: infoLink?.type,
                    })}
                    link={infoLink?.link}
                />
            )}
        </div>
    );
};

export default FormSidebar;
